/*
This software is Copyright ©️ 2020 The University of Southern California. All Rights Reserved. 
Permission to use, copy, modify, and distribute this software and its documentation for educational, research and non-profit purposes, without fee, and without a written agreement is hereby granted, provided that the above copyright notice and subject to the full license file found in the root of this software deliverable. Permission to make commercial use of this software may be obtained by contacting:  USC Stevens Center for Innovation University of Southern California 1150 S. Olive Street, Suite 2300, Los Angeles, CA 90115, USA Email: accounting@stevens.usc.edu

The full terms of this copyright and license should always be found in the root directory of this software deliverable as "license.txt" and if these terms are not found with this software, please contact the USC Stevens Center for the full license.
*/
/**
 * Implement Gatsby's Browser APIs in this file.
 *
 * See: https://www.gatsbyjs.org/docs/browser-apis/
 */
import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import PropTypes from "prop-types";
import {
  createTheme,
  ThemeProvider,
  StyledEngineProvider,
} from "@mui/material/styles";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

import { store, persistor } from "./src/store/store";
import { useWithReduxHydration } from "./src/use-with-redux-hydration";

import "./src/styles/layout.css";
import "./src/styles/styles.css";
import "react-circular-progressbar/dist/styles.css";

function ReduxStoreHydrationComponent({ element }) {
  useWithReduxHydration();
  return <>{element}</>;
}

ReduxStoreHydrationComponent.propTypes = {
  element: PropTypes.node.isRequired,
};

const theme = createTheme({
  palette: {
    primary: {
      main: "#1b6a9c",
    },
  },
});

export const wrapRootElement = ({ element }) => {
  const cache = createCache({
    key: "custom",
  });
  return (
    <StyledEngineProvider injectFirst>
      <CacheProvider value={cache}>
        <ThemeProvider theme={theme}>
          <Provider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <ReduxStoreHydrationComponent element={element} />
            </PersistGate>
          </Provider>
        </ThemeProvider>
      </CacheProvider>
    </StyledEngineProvider>
  );
};
